export class ContactTypeParams {
  id: number;
  typeContact: string; // equals the label of the type contact

  ordreTri: string;
  carnetContactID: number;
  nePasInclureArbreDestinataires: boolean;
  nePasRemplirLaListe: boolean;
  sanctionTypeVictime: boolean;
  categorie: boolean;
  categorieParent: number;
  verrouille: boolean;
  creationGereeParGroupeID: number;
  modificationGereeParGroupeId: number;
  suppressionGereeParGroupeId: number;
  visualisationGereeParGroupeID: number;

  constructor(data?) {
    Object.assign(this, data);
  }
}
